import Filter from "../../components/reportes/Filtros";
import Reporte from "../../components/reportes/Reporte";


const Reportes = ({
    filter,
    setFilter,
    fetch,
    data,
    setData,
    onClick,
    onChange,
    provincias,
    navigate,
    user
  }) => {
    

    return (
        <div className="min-vh-100" style={{ backgroundColor: "#eaeaea" }}>
          <div className="px-3">
            <div className="d-flex">
              <h2 className="me-2">REPORTES</h2>
              <label
                className="btn btn-custom-naranja fw-normal GothamBold text-white px-4 d-flex align-items-center"
                style={{ borderRadius: "10px", height: "45px" }}
              >
                NUEVO REPORTE
                <button
                  className="d-none"
                  name="añadir-reporte"
                  onClick={(event) => onClick(event)}
                ></button>
              </label>
            </div>
            <div className="row">
              <div className="col-md-12">
                <Filter
                  filter={filter}
                  setFilter={setFilter}
                  fetch={fetch}
                  onChange={onChange}
                  provincias={provincias}
                  setData={setData}
                />
              </div>
    
              <div className="col-md-12">
                <div className="my-3">
                  {data.links.map((link) => {
                    if (link.label == "&laquo; Previous") {
                      return (
                        <label
                          className={`btn btn-outline-dark me-1 ${
                            link.active ? "active" : ""
                          } ${link.url ? "" : "disabled"}`}
                        >
                          <i class="bi bi-chevron-left"></i>
                          ANTERIOR
                        </label>
                      );
                    }
                    if (link.label == "Next &raquo;") {
                      return (
                        <label
                          className={`btn btn-outline-dark ${
                            link.active ? "active" : ""
                          } ${link.url ? "" : "disabled"}`}
                        >
                          SIGUIENTE
                          <i class="bi bi-chevron-right"></i>
                        </label>
                      );
                    }
                    return (
                      <label
                        className={`btn btn-outline-dark me-1 ${
                          link.active ? "active" : ""
                        }`}
                      >
                        {link.label}
                      </label>
                    );
                  })}
                  <label className={`btn btn-dark ms-1`}>
                    REPORTES {data?.total}
                  </label>
                </div>
                <div className="table-responsive">

                <table class="table table-striped-columns table-light table-hover">
                  <thead style={{fontSize: "13px"}}>
                    <tr>
                      <th className="d-none d-md-table-cell">
                        <div className="d-flex justify-content-between align-items-center" >
                          #ID
                          <label className="d-flex mx-2 btn px-0 py-0">
                            <i
                              class={`bi bi-arrow-down ${
                                filter.sort == "-reportes.id"
                                  ? "text-dark font-bold"
                                  : "text-muted opacity-25"
                              }`}
                            ></i>
                            <i
                              class={`bi bi-arrow-up ${
                                filter.sort == "reportes.id"
                                  ? "text-dark font-bold"
                                  : "text-muted opacity-25"
                              }`}
                            ></i>
                            <button
                              className="d-none"
                              onClick={() => {
                                let params = filter;
                                if (filter.sort == "-reportes.id") {
                                  setFilter({ ...filter, sort: "reportes.id" });
                                  params = { ...params, sort: "reportes.id" };
                                } else {
                                  setFilter({ ...filter, sort: "-reportes.id" });
                                  params = { ...params, sort: "-reportes.id" };
                                }
                                fetch(setData, params, "/reportes");
                              }}
                            ></button>
                          </label>
                        </div>
                      </th>
                      <th className="">
                        <div className="d-flex justify-content-between align-items-center">
                          FECHA DE COMPRA
                          <label className="d-flex mx-2 btn px-0 py-0">
                            <i
                              class={`bi bi-arrow-down ${
                                filter.sort == "-reportes.created_at"
                                  ? "text-dark font-bold"
                                  : "text-muted opacity-25"
                              }`}
                            ></i>
                            <i
                              class={`bi bi-arrow-up ${
                                filter.sort == "reportes.created_at"
                                  ? "text-dark font-bold"
                                  : "text-muted opacity-25"
                              }`}
                            ></i>
                            <button
                              className="d-none"
                              onClick={() => {
                                let params = filter;
                                if (filter.sort == "-reportes.created_at") {
                                  setFilter({ ...filter, sort: "reportes.created_at" });
                                  params = { ...params, sort: "reportes.created_at" };
                                } else {
                                  setFilter({ ...filter, sort: "-reportes.created_at" });
                                  params = { ...params, sort: "-reportes.created_at" };
                                }
                                fetch(setData, params, "/reportes");
                              }}
                            ></button>
                          </label>
                        </div>
                      </th>
                      <th className="d-none d-md-table-cell">
                        <div className="d-flex justify-content-between align-items-center">
                          EVENTO
                        </div>
                      </th>
                      <th className="">
                        <div className="d-flex justify-content-between align-items-center">
                          CLIENTE
                          <label className="d-flex mx-2 btn px-0 py-0">
                            <i
                              class={`bi bi-arrow-down  ${
                                filter.sort == "-reportes.nombre_cliente"
                                  ? "text-dark font-bold"
                                  : "text-muted opacity-25"
                              }`}
                            ></i>
                            <i
                              class={`bi bi-arrow-up  ${
                                filter.sort == "reportes.nombre_cliente"
                                  ? "text-dark font-bold"
                                  : "text-muted opacity-25"
                              }`}
                            ></i>
                            <button
                              className="d-none"
                              onClick={() => {
                                let params = filter;
                                if (filter.sort == "-reportes.nombre_cliente") {
                                  setFilter({ ...filter, sort: "reportes.nombre_cliente" });
                                  params = { ...params, sort: "reportes.nombre_cliente" };
                                } else {
                                  setFilter({ ...filter, sort: "-reportes.nombre_cliente" });
                                  params = { ...params, sort: "-reportes.nombre_cliente" };
                                }
                                fetch(setData, params, "/reportes");
                              }}
                            ></button>
                          </label>
                        </div>
                      </th>
                      <th className="d-none d-md-table-cell">
                        <div className="d-flex justify-content-between align-items-center">
                          CODIGO
                        </div>
                      </th>
                      <th className="d-none d-md-table-cell">
                        <div className="d-flex justify-content-between align-items-center">
                          ENTRADA
                        </div>
                      </th>
                      <th className="d-none d-md-table-cell">
                        <div className="d-flex justify-content-between align-items-center">
                          FECHA DE FUNCION
                          <label className="d-flex mx-2 btn px-0 py-0">
                            <i
                              class={`bi bi-arrow-down ${
                                filter.sort == "-reportes.fecha"
                                  ? "text-dark font-bold"
                                  : "text-muted opacity-25"
                              }`}
                            ></i>
                            <i
                              class={`bi bi-arrow-up ${
                                filter.sort == "reportes.fecha"
                                  ? "text-dark font-bold"
                                  : "text-muted opacity-25"
                              }`}
                            ></i>
                            <button
                              className="d-none"
                              onClick={() => {
                                let params = filter;
                                if (filter.sort == "-reportes.fecha") {
                                  setFilter({
                                    ...filter,
                                    sort: "reportes.fecha",
                                  });
                                  params = { ...params, sort: "reportes.fecha" };
                                } else {
                                  setFilter({
                                    ...filter,
                                    sort: "-reportes.fecha",
                                  });
                                  params = {
                                    ...params,
                                    sort: "-reportes.fecha",
                                  };
                                }
                                fetch(setData, params, "/reportes");
                              }}
                            ></button>
                          </label>
                        </div>
                      </th>
                      <th className="d-none d-md-table-cell">
                        <div className="d-flex justify-content-between align-items-center">
                          PRECIO
                          <label className="d-flex mx-2 btn px-0 py-0">
                            <i
                              class={`bi bi-arrow-down ${
                                filter.sort == "-reportes.unidad"
                                  ? "text-dark font-bold"
                                  : "text-muted opacity-25"
                              }`}
                            ></i>
                            <i
                              class={`bi bi-arrow-up ${
                                filter.sort == "reportes.unidad"
                                  ? "text-dark font-bold"
                                  : "text-muted opacity-25"
                              }`}
                            ></i>
                            <button
                              className="d-none"
                              onClick={() => {
                                let params = filter;
                                if (filter.sort == "-reportes.unidad") {
                                  setFilter({
                                    ...filter,
                                    sort: "reportes.unidad",
                                  });
                                  params = { ...params, sort: "reportes.unidad" };
                                } else {
                                  setFilter({
                                    ...filter,
                                    sort: "-reportes.unidad",
                                  });
                                  params = {
                                    ...params,
                                    sort: "-reportes.unidad",
                                  };
                                }
                                fetch(setData, params, "/reportes");
                              }}
                            ></button>
                          </label>
                        </div>
                      </th>
                      <th className="d-none d-md-table-cell">
                        <div className="d-flex justify-content-between align-items-center">
                          CANTIDAD
                          <label className="d-flex mx-2 btn px-0 py-0">
                            <i
                              class={`bi bi-arrow-down ${
                                filter.sort == "-reportes.cantidad"
                                  ? "text-dark font-bold"
                                  : "text-muted opacity-25"
                              }`}
                            ></i>
                            <i
                              class={`bi bi-arrow-up ${
                                filter.sort == "reportes.cantidad"
                                  ? "text-dark font-bold"
                                  : "text-muted opacity-25"
                              }`}
                            ></i>
                            <button
                              className="d-none"
                              onClick={() => {
                                let params = filter;
                                if (filter.sort == "-reportes.cantidad") {
                                  setFilter({
                                    ...filter,
                                    sort: "reportes.cantidad",
                                  });
                                  params = { ...params, sort: "reportes.cantidad" };
                                } else {
                                  setFilter({
                                    ...filter,
                                    sort: "-reportes.cantidad",
                                  });
                                  params = {
                                    ...params,
                                    sort: "-reportes.cantidad",
                                  };
                                }
                                fetch(setData, params, "/reportes");
                              }}
                            ></button>
                          </label>
                        </div>
                      </th>
                      <th className="d-none d-md-table-cell">
                        <div className="d-flex justify-content-between align-items-center">
                          SUBTOTAL
                          <label className="d-flex mx-2 btn px-0 py-0">
                            <i
                              class={`bi bi-arrow-down ${
                                filter.sort == "-reportes.total"
                                  ? "text-dark font-bold"
                                  : "text-muted opacity-25"
                              }`}
                            ></i>
                            <i
                              class={`bi bi-arrow-up ${
                                filter.sort == "reportes.total"
                                  ? "text-dark font-bold"
                                  : "text-muted opacity-25"
                              }`}
                            ></i>
                            <button
                              className="d-none"
                              onClick={() => {
                                let params = filter;
                                if (filter.sort == "-reportes.total") {
                                  setFilter({
                                    ...filter,
                                    sort: "reportes.total",
                                  });
                                  params = { ...params, sort: "reportes.total" };
                                } else {
                                  setFilter({
                                    ...filter,
                                    sort: "-reportes.total",
                                  });
                                  params = {
                                    ...params,
                                    sort: "-reportes.total",
                                  };
                                }
                                fetch(setData, params, "/reportes");
                              }}
                            ></button>
                          </label>
                        </div>
                      </th>
                      <th className="d-none d-md-table-cell">
                        <div className="d-flex justify-content-between align-items-center">
                          CUPON
                        </div>
                      </th>
                      <th className="d-none d-md-table-cell">
                        <div className="d-flex justify-content-between align-items-center">
                          DESCUENTO
                          <label className="d-flex mx-2 btn px-0 py-0">
                            <i
                              class={`bi bi-arrow-down ${
                                filter.sort == "-reportes.descuento"
                                  ? "text-dark font-bold"
                                  : "text-muted opacity-25"
                              }`}
                            ></i>
                            <i
                              class={`bi bi-arrow-up ${
                                filter.sort == "reportes.descuento"
                                  ? "text-dark font-bold"
                                  : "text-muted opacity-25"
                              }`}
                            ></i>
                            <button
                              className="d-none"
                              onClick={() => {
                                let params = filter;
                                if (filter.sort == "-reportes.descuento") {
                                  setFilter({
                                    ...filter,
                                    sort: "reportes.descuento",
                                  });
                                  params = { ...params, sort: "reportes.descuento" };
                                } else {
                                  setFilter({
                                    ...filter,
                                    sort: "-reportes.descuento",
                                  });
                                  params = {
                                    ...params,
                                    sort: "-reportes.descuento",
                                  };
                                }
                                fetch(setData, params, "/reportes");
                              }}
                            ></button>
                          </label>
                        </div>
                      </th>
                      <th className="d-none d-md-table-cell">
                        <div className="d-flex justify-content-between align-items-center">
                          TOTAL
                        </div>
                      </th>
                      <th className="d-none d-md-table-cell">
                        <div className="d-flex justify-content-between align-items-center text-nowrap">
                          TOTAL +Serv -Desc
                        </div>
                      </th>
                      <th className="d-none d-md-table-cell">
                        <div className="d-flex justify-content-between align-items-center">ESTADO</div>
                      </th>
                      <th className="d-none d-md-table-cell">
                        <div className="d-flex justify-content-between align-items-center">DATOS DEL PAGO</div>
                      </th>
                    </tr>
                  </thead>
                  <tbody style={{fontSize: "13px"}}>
                    {data.data.map((usuario) => {
                      return (
                        <Reporte
                          data={usuario}
                          onClick={onClick}
                          navigate={navigate}
                          user={user}
                        />
                      );
                    })}
                  </tbody>
                </table>
                </div>
                <div className="my-3">
                  {data.links.map((link) => {
                    if (link.label == "&laquo; Previous") {
                      return (
                        <label
                          className={`btn btn-outline-dark me-1 ${
                            link.active ? "active" : ""
                          } ${link.url ? "" : "disabled"}`}
                        >
                          <i class="bi bi-chevron-left"></i>
                          ANTERIOR
                        </label>
                      );
                    }
                    if (link.label == "Next &raquo;") {
                      return (
                        <label
                          className={`btn btn-outline-dark ${
                            link.active ? "active" : ""
                          } ${link.url ? "" : "disabled"}`}
                        >
                          SIGUIENTE
                          <i class="bi bi-chevron-right"></i>
                        </label>
                      );
                    }
                    return (
                      <label
                        className={`btn btn-outline-dark me-1 ${
                          link.active ? "active" : ""
                        }`}
                      >
                        {link.label}
                      </label>
                    );
                  })}
                  <label className={`btn btn-dark ms-1`}>
                    REPORTES {data?.total}
                  </label>
                </div>
              </div>
            </div>
          </div>
        </div>
    )
}

export default Reportes